import { SupplyBasicFeaturePage } from "..";

/** 酒店供应商主体管理页面。 */
export function HotelsPage() {
  return <SupplyBasicFeaturePage kind="hotels" />;
}
